import { showToast } from './toastBoot';
import { toToastType, type ToastType } from './toastTypes';

// bootstrap-notify 時代の 8 引数を維持するアダプタ。約 230 の js.erb が window.notify として呼ぶ。
// from/align は全呼び出しが top/center、icon・animIn/animOut は使われていない（js.erb は空文字、
// animate.css は読み込まれていない）ため無視する。引数を減らす書き換えは別 issue
/* eslint-disable @typescript-eslint/no-unused-vars -- 互換のため残す未使用の引数 */
export default function flashMessage(
  title: string,
  message: string,
  _from: string,
  _align: string,
  _icon: string,
  type: string,
  _animIn: string,
  _animOut: string,
) {
  showToast({ title, message, type: toToastType(type) });
}
/* eslint-enable @typescript-eslint/no-unused-vars -- 未使用の引数はここまで */

export type FlashMessageType = ToastType;

export function simpleFlashMessage(
  message: string,
  type: FlashMessageType = 'info',
) {
  showToast({ title: '', message, type });
}
